import React, { useState, useEffect } from "react";
import ProcessStatus from "../../enums/ProcessStatus";
import "./ApproverActionPanel.css";

export default function ApproverActionPanel({
  onApprove,
  onReject,
  onNotSure,
  onCommentSend,
  resetSelectionKey
}) {
  const [selection, setSelection] = useState(null);
  const [comment, setComment] = useState("");
  const [showChecks, setShowChecks] = useState(false); // 👈 NEW

  useEffect(() => {
    
      setSelection(null);   // 👈 UNSELECT EVERYTHING
    
  }, [resetSelectionKey]);

  // ⏳ Delay checkboxes (10 sec — change to 10000 if needed)
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowChecks(true);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  const handleApprove = () => {
    setSelection(ProcessStatus.Approve);
    onApprove({ processStatus: ProcessStatus.Approve });
  };

  const handleNotSure = () => {
    setSelection(ProcessStatus.NotSure);
    onNotSure({ processStatus: ProcessStatus.NotSure });
  };

  const handleReject = () => {
    setSelection(ProcessStatus.Reject);

    onReject({
      processStatus: ProcessStatus.Reject,
      comment: null,
    });
  };

  const handleSendComment = () => {
    if (!comment.trim()) return;

    onCommentSend({
      processStatus: ProcessStatus.Reject,
      comment: comment.trim(),
    });

    setComment("");
  };

  return (
    <div className="approver-panel">

      {/* BEFORE TIMEOUT */}
      {!showChecks && (
        <p style={{ opacity: 0.6, fontSize: 14 }}>
          Onay seçenekleri 5 saniye sonra aktif olacaktır...
        </p>
      )}

      {/* AFTER TIMEOUT → FADE-IN */}
      {showChecks && (
        <div className="fade-in">

          {/* APPROVE */}
          <label className="checkbox-row">
            <input
              type="checkbox"
              checked={selection === ProcessStatus.Approve}
              onChange={handleApprove}
            />
            <span>Onaylıyorum</span>
          </label>

          {/* NOT SURE */}
          <label className="checkbox-row">
            <input
              type="checkbox"
              checked={selection === ProcessStatus.NotSure}
              onChange={handleNotSure}
            />
            <span>Emin Değilim</span>
          </label>

          {/* REJECT */}
          <label className="checkbox-row">
            <input
              type="checkbox"
              checked={selection === ProcessStatus.Reject}
              onChange={handleReject}
            />
            <span>Reddediyorum</span>
          </label>

        </div>
      )}
    </div>
  );
}
